export default {
  app: {
    SET_LOCALE: 'SET_LOCALE',
    USER_SIGNIN: 'USER_SIGNIN',
    SIGN_IN_USER_SUCCESS: 'ON_SIGN_IN_SUCCESS',
    SIGN_OUT_USER_SUCCESS: 'SIGNOUT_USER_ON_AUTHENTICATION_FAIL',
    SET_USER_DETAILS: 'SET_USER_DETAILS'
  },
  entities: {
    UPDATE_ENTITIES: 'UPDATE_ENTITIES'
  },
  toast: {
    SHOW_TOAST: 'SHOW_TOAST',
    HIDE_TOAST: 'HIDE_TOAST'
  },
  api: {
    FETCH_NUDGE: 'FETCH_NUDGE'
  }
};
